import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import WaitingModal from '../../generics/WaitingModal';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {print} from 'react-icons-kit/fa/print';
import moment from 'moment';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;
require('../../../assets/datetime-moment.js');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class DiscardUnits extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getReasons = this.getReasons.bind(this);
		this.setTable = this.setTable.bind(this);
		this.getComponents = this.getComponents.bind(this);
		this.printFolioPDF = this.printFolioPDF.bind(this);
		this.getHourFormat = this.getHourFormat.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.getDetailed = this.getDetailed.bind(this);
		this.getStatics = this.getStatics.bind(this);
		this.setTableStatics = this.setTableStatics.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],
			extraction_name:"",

			component_type:"all",
			components:[],
			component_name:"",

			reason:"all",
			reasons:[],
			reason_name:"",

			start_date 	: "",
			end_date 	: "",
			folio:"",

			listado:[],

			change_check: false,

			//test datatable to export
			columns:[
				{title:"Donador"},
				{title:"Componente"},
				{title:"Código"},
				{title:"Vol"},
				{title:"No. Unidad"},
				{title:'G & RH'},
				{title:"F. Extrac"},
				{title:"Motivo Baja"},
				{title:"F. Baja"},
				{title:"Folio Baja"},
				{title:"Tipo Extracción"},
				{title:"Usuario"},
			],
			filename:"Resumen Baja Unidades",
			date:"",
			hour:"",
			search_type:"date",
			blood_components:[],
			blood_component_id:"all",
			blood_component_name:"",
			totals:"",
			date_hour:"",
			medical:"",
			format:"",
			total_list:[],
			listado_pdf:[]
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date:aux[0],
				hour:hours,
				folio:"",
				date_hour:aux[0]+' '+hours,
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});
		});


	}

	componentDidMount(){
		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}
		this.props.waiting.handleShow('Cargando...');
	
		this.getReasons();
		this.getComponents();

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});
	

		fetch(Config.default.apiGateway.URL+'donation_type_extraction', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					extraction_type: response
				});
			}
		});
		
		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getReasons(){
		fetch(Config.default.apiGateway.URL+'discard_reasons',{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({
					reasons: response
				});
			}
		});
	}
	
	getComponents(){
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/by_type?type='+this.state.component_type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({blood_components:response});
			}
		})
	}

	setTable(){
		$.fn.dataTable.moment( 'DD/MM/YYYY');
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
					orientation:'landscape',
					pageSize: 'LEGAL',
                	customize: (doc) => { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						if(this.state.search_type === 'date'){
							doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						}else{
							doc.content.splice(2, 0, {
								columns:[
									{width:'75%', text:""},
									{
										width:'25%',
										text:'Fecha Emisión: '+this.state.date+' '+this.state.hour,
										fontSize:9,
										margin:[0,0,0,10],
										alignment:'center'
									},
								]
							});
						}

						doc.content.splice(3, 0, {
							columns:[
								this.state.component_type !== "all" ?
									{text: 'Tipo Componente', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.component_type !== "all" ?
									{text: this.state.component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.blood_component_id !== "all" ?
									{text: 'Componente', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.blood_component_id !== "all" ?
									{text: this.state.blood_component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Tipo Extracción', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.reason !== "all" ?
									{text: 'Motivo Baja', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.reason !== "all" ?
									{text: this.state.reason_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
						});

						doc.content[4].table.body.map((b, i)=>{
                			b.map((t, j)=>{
                				if(j > 1 && j < 6){
                					b[j].alignment = 'center' 
                				}         				
                			})
                		});

						doc.content[5] = {
							text:'Numero Total de Registros : '+this.state.totals,
							margin:[5,15,0,0]
            			}
							
            			doc.content[4].table.widths=["15%","14%","4%","4%","5%","4%","5%","14%","6%","5%","10%", '14%'];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
            
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",				
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"30em",
			scrollX: true,
			autoWidth: false,
			info:false
		});
		
		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		

		if(e.target.name === 'component_type'){
			if(e.target.value === 'all'){
				this.setState({blood_component_id:'all'});
			}else{
				setTimeout(()=>{
					this.getBloodComponent();
				}, 500);
				this.setState({
					component_name: e.target.options[e.target.selectedIndex].text
				})
			}
		}else if(e.target.name === 'blood_component_id'){
			this.setState({
				blood_component_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'reason'){
			this.setState({
				reason_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'search_type'){
			this.setState({
				component_type:"all",
				blood_component_id:"all",
				extraction_type_id:"all",
				reason:"all",
			});
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					health_facilities_id:this.state.health_facilities_id,
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					extraction_type_id:this.state.extraction_type_id,
					discard_reason_id:this.state.reason,
					component_type: this.state.component_type,
					folio:this.state.folio,
					search_by:this.state.search_type,
					blood_component_id: this.state.blood_component_id,
				};
				
				if(this.state.format === 'detallado'){
					this.setState({
						columns:[
							{title:"Donador"},
							{title:"Componente"},
							{title:"Código"},
							{title:"Vol"},
							{title:"No. Unidad"},
							{title:"G & RH"},
							{title:"F. Extrac"},
							{title:"Motivo Baja"},
							{title:"F. Baja"},
							{title:"Folio Baja"},
							{title:"Tipo Extracción"},
							{title:"Usuario"}
						],
					})
					this.getDetailed(obj);

				}else{
					this.setState({
						columns:[
							{title:"Razón"},
							{title:"Componente"},
							{title:"Tipo Componente"},
							{title:"A+"},
							{title:"A-"},
							{title:"B+"},
							{title:"B-"},
							{title:"O+"},
							{title:"O-"},
							{title:"AB+"},
							{title:"AB-"},
							{title:"Sin Grupo"},
							{title:"Total"}
						],
					})
					this.getStatics(obj);
				}
				
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	setTableStatics(){		
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY")
		this.$el = $(this.el);

		var columns = true;
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	//orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						if(this.state.search_type === 'date'){
							doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						}

						doc.content.splice(3, 0, {
							columns:[
								this.state.component_type !== "all" ?
									{text: 'Tipo Componente', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.component_type !== "all" ?
									{text: this.state.component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.blood_component_id !== "all" ?
									{text: 'Componente', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.blood_component_id !== "all" ?
									{text: this.state.blood_component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Tipo Extracción', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.reason !== "all" ?
									{text: 'Motivo Baja', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.reason !== "all" ?
									{text: this.state.reason_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
						});

						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 1){
								head.push({text:c.title, style:'tableHeader', alignment: i > 2 ? 'right' : 'center'})
							}
							
						})

						

						if(columns){
							this.state.listado_pdf.unshift(head);	
							columns = false;
						}
						


						doc.content[4].table.body = this.state.listado_pdf
					
                		doc.styles.tableBodyOdd.fillColor = "#FFF";
                	
                		doc.content[4].table.widths=["45%","5%","5%","5%","5%","5%","5%","5%","5%","10%","5%"];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
			rowGroup: {
	            dataSrc: [ 0, 1 ],
	            startRender: function ( rows, group ) {	
	     			if(rows.data()[0][0] === group){
		     			return $('<tr/>')
		                    .append( '<td style="background:#c8c8c8;" colspan="'+(rows.data()[0].length-2)+'">'+group+'</td>' );
	     			}else{
	     				var subhead = $('<tr/>')
		                    			.append( 
		                    				'<td style="background:#e5e5e5;font-weight:bold;font-size:14px;" colspan="'+
		                    					(rows.data()[0].length - 3) +'">'+
		                    					group+
		                    				'</td>' 
		                    			)
		                var total = 0
	     				rows.data().map((d)=>{
	     					d.map((v, i)=>{
	     						if(i > 2){
	     							if(v !== ""){
	     								total += parseInt(v);	
	     							}
	     						}
	     					})
	     				})
	     				subhead.append( '<td style="padding:8px;background:#e5e5e5;font-weight:bold;font-size:14px;text-align:right">'+total+'</td>' );

	     				return subhead;
		                    
	     			}
	            },
	        },
	        columnDefs: [ {
	            targets: [ 1, 0 ],
	            visible: false
	        },{
		        targets: [3,4,5,6,7,8,9,10,11,12],
		        className: 'dt-right'
    		} ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
			createdRow: function(row, data, dataIndex){
				$('td:eq(0)', row).attr('style', 'padding-left:4%;');
				
				if(data[2]==='TOTAL'){
					$('td', row).attr('style', 'display:none;');
				}
			}
		});
		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	getStatics(obj){
		this.props.waiting.handleShow('Buscando...');
		fetch(Config.default.apiGateway.URL+'reports/discard_unit_stats_by_group',{
			method: 'POST',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					listado: [],
				});

				if(response.res.length > 0){
					
					var list = [], list_pdf=[];
					var obj = [], obj_pdf = [];
					response.res.map((res)=>{
						obj = [];
						list_pdf.push([
							{text:res.discard_reason, colSpan:11, bold:1, fillColor:'#f0f0f0'},{},{},{},{},{},{},{},{},{},{}
						])
						obj_pdf = [];

						res.component_types.map((comp)=>{
							list_pdf.push([
								{text:comp.component_type, colSpan:11, bold:1, fillColor:'#e5e5e5', margin:[10,0,0,0]},{},{},{},{},{},{},{},{},{},
								{text:res.total, bold:1, fillColor:'#f0f0f0', alignment:'right'}
							]);

							comp.blood_components.map((blood)=>{
								obj = [res.discard_reason, comp.component_type, blood.blood_component];

								obj_pdf = [{text:blood.blood_component, margin:[20,0,0,0]}]
								
								this.state.columns.map((col, i)=>{
									if(i > 2 && i < this.state.columns.length - 1){
										var index = blood.group_stats.findIndex(item => item.text === col.title);

										if(index !== -1){
											obj.push(blood.group_stats[index].num);
											obj_pdf.push({text:blood.group_stats[index].num, alignment:'right'});
										}else{
											if(col.title === 'Sin Grupo'){
												index = blood.group_stats.findIndex(item => item.text === '@@');

												if(index !== -1){
													obj.push(blood.group_stats[index].num);
													obj_pdf.push({text:blood.group_stats[index].num, alignment:'right'});
												}else{
													obj.push('');
													obj_pdf.push({text:''});
												}
											}else{
												obj.push('');
												obj_pdf.push({text:''});
											}
										}
									}
								});

								obj.push(blood.total_by_component);
								obj_pdf.push({text:blood.total_by_component, alignment:'right'});
							
								list.push(obj);
								list_pdf.push(obj_pdf);
							});

						});
					});

					list_pdf.push([{},{},{},{},{},{},{},{},{},{},{}]);

					var totales = ['Totales'];
					var obj_pdf = [{text:'Totales',bold:1,alignment:'right'}]

					this.state.columns.map((col, i)=>{
						if(i > 2 && i < this.state.columns.length - 1){
							var index = response.total_by_groups.findIndex(item => item.text === col.title);

							if(index !== -1){
								totales.push(response.total_by_groups[index].num);
								obj_pdf.push({text:response.total_by_groups[index].num, alignment:'right',bold:1});
							}else{
								if(col.title === 'Sin Grupo'){
									index = response.total_by_groups.findIndex(item => item.text === '@@');

									if(index !== -1){
										totales.push(response.total_by_groups[index].num);
										obj_pdf.push({text:response.total_by_groups[index].num, alignment:'right',bold:1});
									}else{
										totales.push('');
										obj_pdf.push({text:''});
									}
								}else{
									totales.push('');
									obj_pdf.push({text:''});
								}
							}
						}
					});

					totales.push(response.total);
					obj_pdf.push({text:response.total, alignment:'right',bold:1});
					list_pdf.push(obj_pdf);


					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					this.setState({
						listado: list,
						totals: response.total,
						total_list:totales,
						listado_pdf:list_pdf
					});

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTableStatics();
					}, 1000);
				}
					
				
			}
		});
	}

	getDetailed(obj){
		this.props.waiting.handleShow('Buscando...');
		fetch(Config.default.apiGateway.URL+'reports/discard_unit',{
			method: 'POST',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					listado: [],
				});

				if(response.res.length > 0){
					
					var list = [];
					response.res.map((res)=>{
						var l = [];
						l.push(
							res.donor_name,
							res.component_name,
							res.component_code,
							res.volume,
							res.unit_number,
							res.g_rh,
							moment(res.extraction_date).format('DD/MM/YYYY'),
							res.discard_reason,
							moment(res.discard_date).format('DD/MM/YYYY'),
							res.discard_folio,
							res.extraction_type,
							res.username
						)

						return list.push(l);

						
					})

					setTimeout(()=>{
						this.props.waiting.handleShow('Cargando...');
						this.$el = $(this.el);
						this.$el.DataTable().destroy();
						this.$el.empty();
					}, 500);

					this.setState({
						listado: list,
						totals: response.total
					});

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
				}
					
				
			}
		});
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}
	  
	async printFolioPDF(e){
		e.preventDefault();
		this.waiting_modal.handleShow('Imprimiendo...');
					
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.state.listado[0][8];
		obj.file_type = "discard_units";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.waiting_modal.handleClose();
		}else{
			this.waiting_modal.handleClose();
		}
	
		
	}

	directPrint(response, label_type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
	
			this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
		}
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Procesado ->
					{t('sidebar.nav.reports.discard_units')}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>						

								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>		

								{this.state.search_type === 'date' ?
								<div>
									<div className="form-group">
										<span className="span-min">Fecha Desde</span>
										<input type="date" className="form-control hour-input" name="start_date" id="start_date"
											value={this.state.start_date} onChange={this.handleChange} required />
									</div>
									<div className="form-group">
										<span className="span-min">Fecha Hasta</span>
										<input type="date" className="form-control hour-input" name="end_date" id="end_date"
											value={this.state.end_date} onChange={this.handleChange} required />
									</div>
								</div>
								:<div className="form-group">
									<div className="col-xs-12 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio</span>
										<input type="text" className="form-control"  name="folio" id="folio"
											value={this.state.folio} onChange={this.handleChange} />
									</div>
								</div>}

								{this.state.search_type === 'date' ?
								<div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select className="form-control" name="component_type" id="component_type"
										value={this.state.component_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((c, i)=>{
											return <option key={i} value={c.key}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								:null}

								{this.state.component_type !== 'all' && this.state.search_type === 'date' ?
									<div className="form-group">
										<span className="span-min">Componente</span>
										<select type="text" name="blood_component_id" id="blood_component_id" 
											value={this.state.blood_component_id} onChange={this.handleChange}
											className="form-control" required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.blood_components.map((h, i)=>{
												return <option key={i} value={h.id}>
													{h.component}
												</option>
											})}
										</select>
									</div>
								: null}

								
								{this.state.search_type === 'date' ?
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.donation_type_extraction.id}>
												{don.lookup_value}
											</option>
										})}
									</select>
								</div>
								:null}

								{this.state.search_type === 'date' ?
								<div className="form-group">
									<span className="span-min">Motivo de Baja</span>
									<select className="form-control" name="reason" id="reason"
										value={this.state.reason} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.reasons.map((r, i)=>{
											return <option key={i} value={r.discard_reason.id}>
												{r.discard_reason.name}
											</option>
										})}
									</select>
								</div>
								:null}

								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format"
										value={this.state.format} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="detallado">Detallado</option>
										<option value="estadistico">Estadistico</option>
									</select>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-2">
										<img src={this.props.logo_1} style={{width:"80%"}} id="logo" alt=""/>
									</div>
									<div className="col-xs-12 col-sm-8" style={{textAlign:"center"}}>
										<h3>
											<b>{session}</b>
										</h3>
										<h5><u>BAJA DE UNIDADES</u></h5>
									</div>
									
									{this.state.search_type === 'folio' ?
										<div className="col-xs-12 col-sm-2" style={{paddingTop:"30px", textAlign:"right"}}>
											{this.state.date+' '+this.state.hour}
										</div>
									: null}

								</div>
								{this.state.search_type === 'date' ?
									<div className="col-xs-12" >
										<span>
											Información Del:   {this.state.start_date !== "" ? 
												moment(this.state.start_date).format('DD/MM/YYYY')
											:'  '}
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ? 
												moment(this.state.end_date).format('DD/MM/YYYY')
											:'  '}
										</span>
									</div>
								: null}
								

								{this.state.search_type === 'folio' ?
								<div className="col-xs-12" style={{top:"16%"}}>
									<button style={{width:"80px",height:"30px"}} className="form-control" type="button" 
										onClick={this.printFolioPDF} disabled={this.state.listado.length>0?false:true}>
										<SvgIcon size={20} icon={print} />
										<span style={{marginLeft:"5px"}}>Folio</span>
									</button>
								</div>
								:null}
								<div className="col-xs-12" style={{fontSize:'11px'}}>
									{this.state.component_type !== 'all' && this.state.component_type !== ""?
										<span>
											Tipo Componente:  
											<b style={{marginLeft:"5px"}}>{this.state.component_name}</b>
										</span>	
									:null}
									{this.state.blood_component_id !== 'all' && this.state.blood_component_id !== ""?
										<span style={{marginLeft:"10px"}}> 
											Componente:  
											<b style={{marginLeft:"5px"}}>{this.state.blood_component_name}</b>
										</span>	
									:null}
									{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id!== "" ?
										<span style={{marginLeft:"10px"}}>
											Tipo Extracción:  
											<b style={{marginLeft:"5px"}}>{this.state.extraction_name}</b>
										</span>	
									:null}
									{this.state.reason !== 'all' && this.state.reason !== ""?
										<span style={{marginLeft:"10px"}}>
											Motivo Baja:  
											<b style={{marginLeft:"5px"}}>{this.state.reason_name}</b>
										</span>	
									:null}
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>

								{this.state.format === 'estadistico' ?
									<div className="col-xs-12" style={{fontSize:"14px"}}>
										<table className="table">
											<tbody>
												<tr >
												{this.state.total_list.map((t, i)=>{
													return <td key={i} style={
														i===0 ? {width:'25.5%', textAlign:'right', padding:'5px'} :
														i===7? {width:'5%', textAlign:'right', padding:'5px'} : 
														i===8 ? {width:'5.5%', textAlign:'right', padding:'5px'} :
														i===9 ? {width:'8.5%', textAlign:'right', padding:'5px'} :
														i===10 ? {width:'6.5%', textAlign:'right', padding:'5px'} :
														{width:'4.5%', textAlign:'right', padding:'5px'}}
													><b>{t}</b></td>											
												})}
												</tr>
											</tbody>
										</table>
									</div>
								:null}

								<div className="col-xs-12 form-group">
									<label>Numero Total de Registros : </label>{' '+this.state.totals}
								</div>

								
							</div>
						</form>
					</div>
				</div>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations') (DiscardUnits);